/* eslint-disable  */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { CheckboxDropdownContext } from '../context';
import classNames from 'classnames';
import styles from '@dtsl/css-checkbox-dropdown/dist/index.module.css';
function SingleSelectionList(props) {
  let {
    options,
    onSelect,
    noOptionContent
  } = props;
  const {
    setIsOpen,
    selectedValues,
    setSelectedValues
  } = useContext(CheckboxDropdownContext);
  const setValue = selectedObj => {
    fireChangeEvent(selectedObj);
    setSelectedValues([selectedObj]);
    setIsOpen(false);
  };
  const fireChangeEvent = selectedObj => {
    if (selectedObj !== (selectedValues[0] || {}) && onSelect) {
      onSelect(selectedObj);
    }
  };
  const onMouseOver = event => {
    event.stopPropagation();
    event.preventDefault();
    event.target.parentNode.parentNode.children.forEach(node => {
      node.classList.remove('is-hovered');
    });
    event.target.parentNode.classList.add('is-hovered');
  };
  const renderOption = (option, index) => {
    let {
      key = index,
      svg,
      label,
      value
    } = option;
    let isSelected = value === (selectedValues[0] || {}).value || value === (selectedValues[0] || {}).value;
    const optionClass = classNames({
      [styles['sib-dropdown-checkbox-option']]: true,
      [styles['is-selected']]: isSelected,
      [styles['is-hovered']]: isSelected,
      [option.className]: !!option.className
    });
    return /*#__PURE__*/React.createElement("div", {
      key: key || label || value,
      className: optionClass,
      onClick: () => setValue(option),
      onKeyDown: event => {
        if (event.keyCode === 13) {
          setValue(option);
        }
      },
      onMouseOver: onMouseOver,
      role: "option",
      "aria-selected": isSelected ? 'true' : 'false'
    }, /*#__PURE__*/React.createElement("div", {
      tabIndex: "0",
      className: styles['sib-dropdown-checkbox-option__content'],
      title: label
    }, svg && svg, label));
  };
  let ops = options.map((option, index) => {
    return renderOption(option, index);
  });
  return ops.length ? ops : /*#__PURE__*/React.createElement("div", {
    className: styles['sib-dropdown-checkbox-option'],
    role: "option"
  }, /*#__PURE__*/React.createElement("div", {
    tabIndex: "0",
    className: styles['sib-dropdown-checkbox-option__content']
  }, noOptionContent));
}
SingleSelectionList.defaultProps = {
  isLoading: false,
  onSelect: () => {},
  options: [],
  noOptionContent: 'No options to select'
};
SingleSelectionList.propTypes = {
  isLoading: PropTypes.bool,
  onSelect: PropTypes.func,
  noOptionContent: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    label: PropTypes.string,
    value: PropTypes.any,
    svg: PropTypes.node
  }))
};
export default SingleSelectionList;